/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-10 15:21:56                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-03-03 14:58:36                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
  * WorkorderListItem: Display workorder list item
*/

/* Imports */
/***/

/* Components */
import { IconButton } from "@material-tailwind/react";
import { TrashIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import Loading from "../../../../components/loading/Loading";
import toast from "react-hot-toast";
import { showApiErrorToast } from "../../../../services/api/error";
/***/

import DeleteUserModal from "./modals/DeleteUserModal";
import EditCreateDrawer from "../../../../components/edit-create-drawer/EditCreateDrawer";
import TechnicianForm, { TechnicianFormValidator } from "../../../../components/data/technician/TechnicianForm";
import { validator } from "../../../../services/form-validator/form-validator";
import { api } from "../../../../services/api/api";
import UserForm, { UserFormValidator } from "../../../../components/data/user/UserForm";

/**
* WorkorderListItem: Display workorder list item
* @param workorder - Workorder data
* @param onClick - On click event
* @param isLast - Is last item
*/
export default function UsersAdminActions({
  user,
  onChange
}: {
  user: EasyTech.User,
  onChange?: () => void
}) {
  const [delLoad, setDelLoad] = useState<boolean>(false); 

  const deleteUser = () => {
    setDelLoad(true);
  };

  /**
  * updateTechnician: update technician information
  * @param tech - technician data to update
  */
  const updateTechnician = (tech: EasyTech.Technician): Promise<void> => {
    return new Promise((resolve, reject) => {
      if (validator.isFormValid(tech, TechnicianFormValidator)) {
        api.put(`admin/technicians/${tech.id}`, tech).then((ret) => {
          onChange?.();
          toast.success("Technician updated");
          return resolve();
        }).catch((error) => {
          console.error(error);
          showApiErrorToast(error, { fallbackMessage: "Erreur lors de la mise à jour du technicien" });
          return reject();
        });
      } else {
        toast.error("Form is invalid");
        return reject();
      }
    });
  };
  /***/

  /**
  * updateTechnician: update technician information
  * @param usr - technician data to update
  */
  const updateUser = (usr: EasyTech.User): Promise<void> => {
    return new Promise((resolve, reject) => {
      if (validator.isFormValid(usr, UserFormValidator)) {
        api.put(`admin/users/${usr.id}`, usr).then((ret) => {
          onChange?.();
          toast.success("User updated");
          return resolve();
        }).catch((error) => {
          console.error(error);
          showApiErrorToast(error, { fallbackMessage: "Erreur lors de la mise à jour de l'utilisateur" });
          return reject();
        });
      } else {
        toast.error("Form is invalid");
        return reject();
      }
    });
  };
  /***/

  return(
    <div className="admin-wo-actions" data-no-link onClick={e => e.stopPropagation()} onMouseDown={e => e.stopPropagation()}>

      {(delLoad === false) ?
        <IconButton onClick={deleteUser} 
          variant="text"
          className={"icon-btn"} 
          size="sm">
          <TrashIcon className="w-[16px]"  />
        </IconButton>
      :
        <Loading size="h-4 w-4" />  
      }

      {user.userType === "USER" ?
        <EditCreateDrawer data={(user as EasyTech.User)}
                        entityName="User"
                        FormComponent={UserForm}
                        isNotCreatable={true}
                        onSubmit={updateUser} />
      :
        <EditCreateDrawer data={(user as EasyTech.Technician)}
                          entityName="Technician"
                          FormComponent={TechnicianForm}
                          isNotCreatable={true}
                          onSubmit={updateTechnician} />
      }

      
      {delLoad &&
        <DeleteUserModal open={delLoad} user={user} 
        onDelete={() => onChange?.()} onClose={() => setDelLoad(false)} /> 
      }
    </div>
  );
}
/***/
